import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class TicketRefund extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="ticketRefund">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="first">
                        <div className="title">退票收费规则</div>
                        {/* <div style={{"textIndent":"2em"}}>乘客确认订单后，若行程计划出现变更可申请取消订单或者改签。距离发车时间之前均可申请取消订单，改签将于发车前2小时停止，请乘客按照行程计划合理安排时间。旅客退改签按以下规定计收费用：</div> */}
                        <div className="rule">（一）、取消订单收费标准</div>
                        <div>1、申请取消订单时间距离发车时间超过24小时，不收手续费；</div>
                        <div>2、申请取消订单时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；</div>
                        <div>3、申请取消订单时间距离发车时间超过2小时且不足12小时，收取订单金额20%手续费；</div>
                        <div>4、申请取消订单时间距离发车时间不足2小时不可取消订单。</div>
                        <div className="rule">（二）、变更订单收费标准</div>
                        <div>1、申请改签时间距离发车时间超过24小时，不收取手续费；</div>
                        <div>2、申请改签时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；</div>
                        <div>3、申请改签时间距离发车时间超过2小时且不足12小时，收取订单金额10%手续费；</div>
                        <div>4、申请改签时间距离发车时间不足2小时不支持改签。</div>
                        <div className="colorRed">改签须知：低价座位改签到高价座位时须补全差价，高价座位改签到低价座位时不退差价。</div>
                        <div className="rule">（三）、特别提示：</div>
                        <div>1、网上取消订单不提供取消订单凭证！</div>
                        <div>2、行程订单距离发车时间不足2小时，确认下单后不支持退、改签；</div>
                        <div>3、小数点以后按四舍五入来计算。</div>
                        <div className="rule">（四）、免责申明：</div>
                        <div>下列情况下，非平台自身原因导致的，本公司不承担违约责任：</div>
                        <div>1、因极端天气自然灾害（暴雨，暴雪，台风，地震等）导致车辆不能准时出发的；</div>
                        <div>2、因临时修桥、修路、封路等导致车辆不能准时出发的；</div>
                        <div>3、因临时限行，限号等导致车辆不能准时出发的；</div>
                        <div>4、因其他不可抗力因素或乘客严重违反平台规则导致驾驶员无法正常接送或者车辆不能准时出发的。</div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/TicketRefund/index.js